const domUtils = {
  /**
   * 查找指定名称的父级组件后，触发自定义事件
   * @param {*} componentName 父级组件名称
   * @param {*} eventName //自定义事件名称
   * @param {*} params //参数
   */
  dispatch(vc, componentName, eventName, params) {
    var parent = vc.$parent || vc.$root
    if (!parent) {
      return
    }
    var name = parent.$options.componentName
    while (parent && (!name || name !== componentName)) {
      parent = parent.$parent
      if (parent) {
        name = parent.$options.componentName
      }
    }
    if (parent) {
      parent.$emit.apply(parent, [eventName].concat(params))
    }
  }
}
export default domUtils



// WEBPACK FOOTER //
// ./src/api/utils/domUtils.js